<template>
  <div class="field-preview">
    <div class="field-label">
      <span>{{ field.label }}</span>
      <v-chip x-small color="primary" class="ml-2" v-if="field.required">Required</v-chip>
    </div>

    <div class="signature-preview-container">
      <div class="signature-preview-box">
        <v-icon color="grey lighten-1" size="32">mdi-draw</v-icon>
        <span class="signature-preview-text">{{ field.hint || 'Signature area' }}</span>
      </div>
    </div>

    <div class="field-description" v-if="field.description">
      <v-icon small color="grey">mdi-information-outline</v-icon>
      <span>{{ field.description }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignatureFieldPreview',
  props: {
    field: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.field-preview {
  display: flex;
  flex-direction: column;
}

.field-label {
  font-weight: 500;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.signature-preview-container {
  margin-bottom: 8px;
}

.signature-preview-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 120px;
  border: 2px dashed #e0e0e0;
  border-radius: 8px;
  background-color: #f5f7fa;
}

.signature-preview-text {
  margin-top: 8px;
  color: #9e9e9e;
  font-style: italic;
  font-size: 0.9rem;
}

.field-description {
  margin-top: 4px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
